type GetCurrentUserResult = overwolf.profile.GetCurrentUserResult;
// -----------------------------------------------------------------------------
export class OWProfile {
  // ---------------------------------------------------------------------------
  public static async getCurrentUser(): Promise<GetCurrentUserResult> {
    return new Promise(resolve => {
      overwolf.profile.getCurrentUser(resolve);
    });
  }

  public static openLoginDialog(): void {
    overwolf.profile.openLoginDialog();
  }
}
